module.exports = __webpack_public_path__ + "img/og-screen-1.45f48a0b.png";